<template>
  <div>
    <t-navbar/>
    <v-container>
      <v-form
        class="mt-16"
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-container>
          <v-card
            elevation="2"
            outlined
            class="pa-5"
            v-if="plan"
          >
            <v-card-title>Plano escolhido para assinatura</v-card-title>
            <v-card-title>{{plan.name}}</v-card-title>
            <v-card-text>
              <p><strong>R${{formatCurrencyBrazil(plan.value)}}</strong></p>
              <span v-html="plan.description"></span>
            </v-card-text>
          </v-card>
          <v-card
            elevation="2"
            outlined
            class="pa-5"
            title="Dados de usuário"
          >
            <v-card-title>Dados do Assinante</v-card-title>
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.name"
                    :rules="[v => !!v || 'Nome é obrigatório']"
                    label="Nome"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.email"
                    :rules="[
                      v => !!v || 'Email é obrigatório',
                      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                    ]"
                    label="E-mail"
                    type="email"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.documents[0].value"
                    :rules="[v => !!v || 'CPF é obrigatório']"
                    v-mask="'###.###.###-##'"
                    label="CPF"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.phone.areaCode"
                    :rules="[v => !!v || 'DDD é obrigatório']"
                    v-mask="'##'"
                    :counter="2"
                    label="DDD"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.phone.number"
                    v-mask="'#####-####'"
                    :rules="[v => !!v || 'Número de telefone/celular é obrigatório']"
                    label="Telefone/Celular"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card
            elevation="2"
            outlined
            class="pa-5 mt-5"
            title="Dados de usuário"
          >
            <v-card-title>Endereço de cobrança do assinante</v-card-title>
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.address.street"
                    :rules="[v => !!v || 'Endereço é obrigatório']"
                    label="Endereço"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.address.number"
                    :rules="[v => !!v || 'Número é obrigatório']"
                    label="Número"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.address.complement"
                    label="Complemento"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.address.district"
                    :rules="[v => !!v || 'Bairro é obrigatório']"
                    label="Bairro"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.address.city"
                    :rules="[v => !!v || 'Cidade é obrigatório']"
                    label="Cidade"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.address.state"
                    :rules="[v => !!v || 'Estado é obrigatório']"
                    label="Estado"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="userData.sender.address.postalCode"
                    :rules="[v => !!v || 'CEP é obrigatório']"
                    label="CEP"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card
            elevation="2"
            outlined
            class="pa-5 mt-5"
            title="Dados de usuário"
          >
            <v-card-title>Dados do cartão (não são salvos na nossa base)</v-card-title>
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    outlined
                    v-model="userData.paymentMethod.creditCard.holder.name"
                    :rules="[v => !!v || 'Nome do cartão é obrigatório']"
                    label="Nome no cartão"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="userData.paymentMethod.creditCard.holder.birthDate"
                    :rules="[v => !!v || 'Data de nascimento é obrigatório']"
                    v-mask="'##/##/####'"
                    label="Data de nascimento"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="creditCard.number"
                    :rules="[v => !!v || 'Número do cartão é obrigatório']"
                    label="Número do cartão"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="creditCard.month"
                    v-mask="'##'"
                    :rules="[v => !!v || 'Mês de validade é obrigatório']"
                    :counter="2"
                    label="Mês de validade"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="creditCard.year"
                    :rules="[v => !!v || 'Ano de validade é obrigatório']"
                    v-mask="'####'"
                    :counter="4"
                    label="Ano de validade"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    outlined
                    v-model="creditCard.cvv"
                    :rules="[v => !!v || 'CVV é obrigatório']"
                    v-mask="'###'"
                    label="CVV"
                    required
                  ></v-text-field>
                </v-col>

              </v-row>
            </v-card-text>
            <v-card-actions right>
              <v-row
                align="center"
                justify="end"
              >
                <v-btn @click="registerDataStudent()" color="primary" depressed>
                  Finalizar pagamento
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-form>
    </v-container>
  </div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'
import notification from '@/support/mixins/notifications.mixin'
import formErrors from '@/support/mixins/form-errors.mixin'
import PlanService from '@/services/plan/Plan'
import formatter from '@/support/mixins/formatter.mixin'
import estados from '@/domains/data-student/components/estados.js'
import TNavbar from '@/components/TNavbar'
import { mapGetters } from 'vuex'
import formatMoney from '@/support/mixins/format-money.mixin'

export default {
  mixins: [notification, formErrors, formatter, formatMoney],
  components: {
    TNavbar
  },
  data () {
    return {
      valid: true,
      code: '',
      planService: new PlanService(),
      plans: [],
      plan: { label: 'Plano', value: '' },
      payment: '',
      states: estados,
      creditCard: {
        number: '4111111111111111',
        month: '12',
        year: '2030',
        cvv: '123'
      },
      brand: '',
      token: '',
      userData: {
        sender: {
          name: '',
          email: 'c72610042928171701150@sandbox.pagseguro.com.br',
          hash: '',
          phone: {
            areaCode: '',
            number: ''
          },
          address: {
            street: '',
            number: '',
            complement: '',
            district: '',
            city: '',
            state: '',
            country: '',
            postalCode: ''
          },
          documents: [
            {
              type: 'CPF',
              value: '00000000191'
            }
          ]
        },
        paymentMethod: {
          type: 'CREDITCARD',
          creditCard: {
            token: '',
            holder: {
              name: 'Nome Comprador',
              birthDate: '11/01/1984',
              phone: {
                number: '',
                areaCode: ''
              },
              documents: [
                {
                  type: 'CPF',
                  value: ''
                }
              ]
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('Login', ['isLoggedIn'])
  },
  mounted () {
    if (!this.isLoggedIn) {}
    this.code = this.$route.params.code
    this.getSession()
    this.getPlan()
  },
  methods: {
    async getPlan () {
      try {
        const { data } = await this.planService.getPlanByCode(this.code)
        this.plan = data
      } catch (error) {
        console.log(error)
      }
    },
    registerDataStudent () {
      console.log(this.$refs.form.validate())
      if (this.$refs.form.validate()) {
      }
      const ultimo = this.userData.sender.phone.number.length
      const ddd = this.userData.sender.phone.number.substring(0, 2)
      const phone = this.userData.sender.phone.number.substring(2, ultimo)
      this.userData.sender.phone.number = phone
      this.userData.sender.phone.areaCode = ddd
      this.userData.paymentMethod.creditCard.holder.phone.number = phone
      this.userData.paymentMethod.creditCard.holder.phone.areaCode = ddd
      this.userData.paymentMethod.creditCard.holder.documents = this.userData.sender.documents
      this.userData.plan = this.plan.value
      this.getBrand()
      this.getSenderHash()
      this.userData.paymentMethod.creditCard.token = this.token
      // this.userData.paymentMethod.creditCard.holder.name = this.teste.name
      // const fields = [this.$v.userData]
      this.planService
        .payPreApproval(this.userData)
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log('Erro no pagamento => ', error)
        })
    },
    getSenderHash () {
      // eslint-disable-next-line no-undef
      PagSeguroDirectPayment.onSenderHashReady((response) => {
        if (response.status === 'error') {
          return false
        }
        this.userData.plan = this.$route.params.code
        this.userData.sender.hash = response.senderHash // Hash estará disponível nesta variável.
      })
    },
    getBrand () {
      // this.creditCard.number = this.creditCard.number.replace(' ', '')
      const cardBin = this.creditCard.number
      const self = this
      // eslint-disable-next-line no-undef
      PagSeguroDirectPayment.getBrand({
        cardBin,
        success: function (response) {
          self.getCardToken(response.brand.name)
        },
        error: function (response) {
          // eslint-disable-next-line no-console
          console.log(response)
        }
        // complete: function (response) {}
      })
    },
    getCardToken (brand) {
      // eslint-disable-next-line no-undef
      PagSeguroDirectPayment.createCardToken({
        cardNumber: this.creditCard.number, // Número do cartão de crédito
        brand: brand, // Bandeira do cartão
        cvv: this.creditCard.cvv, // CVV do cartão
        expirationMonth: this.creditCard.month, // Mês da expiração do cartão
        expirationYear: this.creditCard.year, // Ano da expiração do cartão, é necessário os 4 dígitos.
        success: (response) => {
          // eslint-disable-next-line no-console
          console.log(response)
          this.form.paymentMethod.creditCard.token = response.card.token
        },
        error: function (response) {
          // eslint-disable-next-line no-console
          console.log(response)
        }
        // complete: function (response) {
        //   // Callback para todas chamadas.
        // }
      })
    },
    async getSession () {
      try {
        const { data } = await this.planService.getSession()
        console.log(data)
        PagSeguroDirectPayment.setSessionId(data.session.id)
      } catch (error) {
        console.log(error)
      }
    },
    setSelected (value) {
      return value.value
    }
  },
  validations: {
    userData: {
      sender: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        phone: {
          number: {
            required
          }
        },
        address: {
          street: {
            required
          },
          number: {
            required
          },
          complement: {
            required
          },
          district: {
            required
          },
          city: {
            required
          },
          state: {
            required
          },
          country: {
            required
          },
          postalCode: {
            required
          }
        },
        documents: {
          value: {
            required
          }
        }
      },
      paymentMethod: {
        creditCard: {
          holder: {
            birthDate: {
              required
            }
          }
        }
      }
    }
  }
}
</script>
<style >
.title-data-h1 {
  font-size: 1.5rem;
  font-weight: 500;
}
.radio-inline {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: 400;
  vertical-align: middle;
  cursor: pointer;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .cardWrap {
    width: 100%;
    padding: 0;
  }
  .cardWrap button {
    width: 100px !important;
  }
}
</style>
